module.exports = __webpack_public_path__ + "img/2.03cde6cd.jpg";